module.exports = __webpack_public_path__ + "static/azuth-symbol-DND3_FnP-8eeaffcaf1d2caa6bf7406f996bb14e3.webp";